__turbopack_context__.v({
  "className": "pretendard_1dae4918-module__A0906G__className",
  "variable": "pretendard_1dae4918-module__A0906G__variable",
});
